import React from 'react'

function Testtomonial() {
  return (
    <div>
           {/* <!-- GT Testimonial Section Start --> */}
        <section class="gt-testimonial-section section-padding fix section-bg-3">
            <div class="container">
                <div class="gt-testimonial-wrapper">
                    <div class="row g-4">
                        <div class="col-lg-6">
                            <div class="gt-testimonial-left-content">
                               <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i>CUSTOMER TESTIMONIALS</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">Hear from Happy Homeowners</h2>
                                </div>
                                <p class="gt-testimonial-text wow fadeInUp" data-wow-delay=".4s">
                                   Discover what our satisfied homeowners have to say about their journey. Real stories, real experiences, and real trust—built one home at a time.
                                </p>
                                <div class="gt-client-info wow fadeInUp" data-wow-delay=".6s">
                                    <div class="gt-client-image">
                                        <img src="assets/img/home-1/testimonial/client-info.png" alt="img"/>
                                    </div>
                                    <h3>More then <span>25K</span> clients Reviews</h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="swiper testimonial-slider">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="gt-testimonial-box">
                                            <div class="quote-icon">
                                                <img src="assets/img/home-1/testimonial/quote.png" alt="img"/>
                                            </div>
                                            <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star color-2"></i>
                                            </div>
                                            <p class="gt-testi-text">
                                            "From the first visit to handing over the keys, everything was seamless. Shree JRB Group truly cares about its clients!"
                                            </p>
                                            <div class="gt-client-info">
                                                <div class="gt-client-image">
                                                    <img src="assets/img/home-1/testimonial/client-info-right-img.png" alt="img"/>
                                                </div>
                                                <div class="gt-client-content">
                                                    <h4>Mohan Lal</h4>
                                                    {/* <p>Product Manager</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="gt-testimonial-box">
                                            <div class="quote-icon">
                                                <img src="assets/img/home-1/testimonial/quote.png" alt="img"/>
                                            </div>
                                            <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star color-2"></i>
                                            </div>
                                            <p class="gt-testi-text">
                                                "Our dream home became a reality thanks to Shree JRB Group. Exceptional service and attention to detail!"
                                            </p>
                                            <div class="gt-client-info">
                                                <div class="gt-client-image">
                                                    <img src="assets/img/home-1/testimonial/client-info-right-img.png" alt="img"/>
                                                </div>
                                                <div class="gt-client-content">
                                                    <h4>Marvin McKinney</h4>
                                                    {/* <p>Product Manager</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="gt-testimonial-box">
                                            <div class="quote-icon">
                                                <img src="assets/img/home-1/testimonial/quote.png" alt="img"/>
                                            </div>
                                            <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star color-2"></i>
                                            </div>
                                            <p class="gt-testi-text">
                                              "Every interaction with Shree JRB Group was professional and warm. The property exceeded all our expectations!"
                                            </p>
                                            <div class="gt-client-info">
                                                <div class="gt-client-image">
                                                    <img src="assets/img/ho me-1/testimonial/client-info-right-img.png" alt="img"/>
                                                </div>
                                                <div class="gt-client-content">
                                                    <h4>Mukesh Yadav</h4>
                                                    {/* <p>Product Manager</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="array-button-2 justify-content-center">
                                        <button class="array-prev"><i class="fa-solid fa-chevron-left"></i></button>
                                        <div class="swiper-dot1">
                                            <div class="dot"></div>
                                        </div>
                                        <button class="array-next"><i class="fa-solid fa-chevron-right"></i></button>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
  )
}

export default Testtomonial